import {useState} from 'react';

export default function usePopoverState() {
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return {
        open: open,
        onOpen: handleOpen,
        onClose: handleClose
    }
}